/**
 * `utmKeyMapping` maps the UTM keys we expect in Cloud (object keys) to their
 *  possible query parameter equivalents, including shorthand syntax (the
 *  arrays).
 *
 * Notes:
 * - `selectedStore` was accidentally added instead of utm_content on the retail
 *   agent page. Keeping it for backwards compatibility (existing bookmarks,
 *   etc.)
 */

export const utmKeyMapping = {
  utm_source: ['utm_source', 'cs'],
  utm_medium: ['utm_medium', 'cm'],
  utm_campaign: ['utm_campaign', 'cn'],
  utm_term: ['utm_term', 'ck'],
  utm_content: ['utm_content', 'cc', 'selectedStore'],
  utm_id: ['utm_id', 'ci'],
  google_ads_click_id: ['gclid'],
  google_ads_gbraid: ['gbraid'],
  google_ads_wbraid: ['wbraid'],
  // custom fields added for Holu
  utm_channel: ['utm_channel'],
  utm_target: ['utm_target'],
  utm_level: ['utm_level'],
  ga_client_id: ['ga_client_id', 'gaClientId'],
};

export type UTMKeys = keyof typeof utmKeyMapping;
